import React from "react"
import { CurrencyFormat } from "../../../Formatters"

export default function AboutData(minAge, maxAge, minCoverageAmount, maxCoverageAmount) {
    return {
        title: "About Whole Life Insurance",
        content:
            "Whole life insurance is an affordable guaranteed insurance solution that offers lifelong coverage.  Unlike term insurance, which offers temporary coverage for a limited time period, whole life insurance offers permanent coverage for your “whole” life as long as you continue to pay your premiums.  With whole life insurance, the coverage and premium amounts are guaranteed to remain the same and your policy cannot be cancelled.  In addition, whole life allows for the guaranteed cash accumulation that can be accessed via tax-free loans to supplement retirement income later in life.  Whole life insurance is available to individuals up to age 80 with a simple and straightforward application process.",
        productData: [
           {
                title: "Who can apply?",
                text: `U.S. citizens or permanent residents ages ${minAge} days - ${maxAge} years`,
            },
            {
                title: "Coverage Amount",
                text: <span><CurrencyFormat number={minCoverageAmount} whole /> - <CurrencyFormat number={maxCoverageAmount} whole />+</span>,
            },
            {
                title: "Product Features",
                text: [
                    "Guaranteed permanent coverage and cash accumulation", 
                    "Fixed premiums even if health changes",
                    "Policy cannot be cancelled",
                    "Tax-free loans to supplement retirement income",
                    "Tax free death benefit payable to designated beneficiaries",
                ]
            }
        ]
    }
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/WholeLife/AboutData.js